import { Entry, NavbarEntry } from '@/types/base/navigation';
import { AppRoutes } from '@/utils';
import { isEmpty } from 'lodash-es';

export const updateNestedMenuPartnerScore = (
  id: 'PARTNERSCORE',
  entry: Entry,
  label: string,
  competitor: unknown,
): NavbarEntry => {
  return {
    ...entry,
    route: AppRoutes[id as keyof typeof AppRoutes],
    label: label,
    items: entry.items?.map(subMenuItem => ({
      ...subMenuItem,
      ...(subMenuItem.id === 'COMPETITOR_ANALYSIS' && isEmpty(competitor) && { disabled: true }),
    })),
  };
};

// Aggregated Scientific Information stays visible in the Aggregated Engagement dropdown
// regardless of the feature flag. While the flag is off the entry is not navigable and
// carries a "Coming soon" chip; enabling the flag turns it into a normal link.
export const applyAggregatedScientificInformationComingSoon = (entry: NavbarEntry, isEnabled: boolean): NavbarEntry => {
  if (!entry.items) return entry;
  return {
    ...entry,
    items: entry.items.map(subMenuItem =>
      subMenuItem.id === 'AGGREGATED_SCIENTIFIC_INFORMATION_GROUP'
        ? { ...subMenuItem, comingSoon: !isEnabled }
        : subMenuItem,
    ),
  };
};

// Top-level entries cannot declare a feature flag in settings.json — `NavEntry` only honours
// `featureFlag` on submenu items — so flag-gated root entries are dropped from the order here.
export const excludeDisabledEntryIds = (entryIds: string[], flagStateByEntryId: Record<string, boolean>): string[] =>
  entryIds.filter(id => flagStateByEntryId[id] !== false);
